import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card";
import gForm from "@/components/g-form/g-form.vue";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import AccountLoged from "@/shared/mixins/AccountLoged";

const name = 'ProdutoRepeticaoAlteracaoInicio'
export default {
  name,

  components: {
    'g-card' :gCard,
    'g-button' : gButton,
    'g-form': gForm
  },

  props: { },

  mounted () {
  // this.popularDropDownRepresentante()
  // this.popularDropDownCliente()
  this.EmpresaArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
  this.mitt.on('trocaEmpresaRepresentante', () => {
    this.atualizaEmpresaRepresentante()
  })
},

  updated () { },

  data () {
    return {
      RepresentanteSelecionado: this.$store.state.representanteSelecionadoId,
      RepresentantesArray: this.$store.state.RepresentanteArray,

      ClienteSelecionado:null,
      ClientesArray:[],

      EmpresaSelecionada: this.$store.state.empresaSelecionadaId,
      EmpresaArray:[],
      PrdodutoId:null,
      OrcamentoId:null,
      CidadeId:null,
      escritobotao: true,
      largura: "240px",
      timer: null,
    }
  },

  mixins:[AccountLoged],

  methods: {

    procurarRepresentante(){
      this.popularDropDownRepresentante()
    },

    atualizaEmpresaRepresentante(){
      this.RepresentantesArray = this.$store.state.RepresentanteArray;
      this.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
      this.RepresentanteSelecionado = this.$store.state.representanteSelecionadoId;
    },

    procurarEmpresa(){
      this.popularDropDownEmpresa()
    },

    buscarClientes(buscaEscrita){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClientesArray = ClienteController.getClienteByEmpresaRepresentanteNome(this.EmpresaSelecionada, this.RepresentanteSelecionado, buscaEscrita).ClientesArray;
      }, 1000);
    },

    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        RepresentanteController
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario(event).RepresentanteArray;
      }, 1000);
    },


    continuarpt2 () {


      setTimeout(() => {
      if(this.ClienteSelecionado != null && this.RepresentanteSelecionado != null && this.EmpresaSelecionada != null) {
        this.gerarOrcamentoNovo()
      }
      else{
          this.$toast.add({ severity: 'error', summary: 'Erro ao preencher os dados', detail: 'Cliente, Unidade e Representante são compos obrigadórios', life: 5000 });
      }
    },
     1100)
    },

    paginainicial(){
      this.$emit('voltarinicio');
    },

    popularDropDownRepresentante(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Representante/GetRepresentanteByCliente/${this.ClienteSelecionado}`,

      })
        .then((response) => {
          this.RepresentantesArray = response.data.data
        })
        .catch(() => {
        });
    },

    popularDropDownCliente(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Cliente/get',
      })
        .then((response) => {
          this.ClientesArray = response.data.data
        })
        .catch(() => {
        });
    },

    zerarcampos(){
      this.RepresentanteSelecionado = null;
      this.ClienteSelecionado = null;
    },

    popularDropDownEmpresa(){
      this.axios({
        method: 'get',
        url:  process.env.VUE_APP_WEB_API + `Cliente/GetUnidadeByClienteId/${this.ClienteSelecionado}`,
      })
        .then((response) => {
          onchange
          this.EmpresaArray = response.data.data

        })
        .catch(() => {
        });
    },

    gerarOrcamentoNovo(){


        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cliente/GetByCliente',
          data: {
          Id: this.ClienteSelecionado,
          }
        })
          .then((response) => {
            if(response.data.data === null) {
              return

            }else{
              this.CidadeId = response.data.data[0].cidadeId

              this.escritobotao = false
              this.largura = "35px"

              this.axios({
                method: 'post',
                url: process.env.VUE_APP_WEB_API + 'orcamento/post',
                data: {
                  ClienteId: this.ClienteSelecionado,
                  RepresentanteId: this.RepresentanteSelecionado,
                  EmpresaId: this.EmpresaSelecionada,
                  Cidadeid:this.CidadeId,
                  TipoFluxoOrcamento: 2,
                }
              })
                .then((response) => {
                  if(response.data.data === null) {
                    return
                  } else {
                    this.OrcamentoId=response.data.data
                  }
                  this.$router.push(`/produto-repeticao-alteracao/${this.OrcamentoId}/info-cliente-ra`)
                })
                .catch(() => {
                });

            }
          })
          .catch(() => {
          });















    },
  },

  computed: { },

};